import React, { useState } from 'react';
import { Grid, Typography, TextField, MenuItem, Button } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

export default function DeepgramForm(props) {
  const { state, onChange, error, onError } = props;
  const [applicationFocus, setApplicationFocus] = useState(false);
  let channels = [];
  for (let index = 5; index <= 150; index += 5) {
    channels.push({ value: index, label: index.toString() });
  }
  channels.push({ value: 1000, label: 'unlimited' });

  const onAdd = () => {
    onChange(
      'applicationID',
      [
        ...state.applicationID,
        {
          key: state.applicationID.length,
          id: '',
        },
      ],
      3
    );
  };

  const onEdit = (event) => {
    const editedItem = {
      key: parseInt(event.target.id),
      id: event.target.value,
    };
    const newItems = state.applicationID.map((item) => {
      for (const key in item) {
        if (key === 'key' && item[key] === editedItem.key) {
          item['id'] = editedItem.id;
        }
      }
      return item;
    });
    onChange('applicationID', newItems, 3);
  };
  const onRemove = () => {
    if (state.applicationID.length > 1)
      onChange(
        'applicationID',
        state.applicationID.splice(0, state.applicationID.length - 1),
        3
      );
  };

  return (
    <React.Fragment>
      <Typography variant='h5' mb={3}>
        Deepgram Asterisk Integration
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            id='channels'
            name='channels'
            label={
              <Typography sx={{ display: 'flex' }}>
                Channels{' '}
                <Tooltip
                  title={
                    <Typography color='inherit' sx={{ fontSize: '15px' }}>
                      The number of simultaneous real-time call transcriptions
                    </Typography>
                  }
                  arrow
                >
                  <HelpOutlineOutlinedIcon sx={{ marginLeft: '10px' }} />
                </Tooltip>
              </Typography>
            }
            fullWidth
            autoComplete='channels'
            variant='outlined'
            value={state.channels}
            onChange={(event) => {
              onChange(event.target.name, event.target.value, 3);
            }}
            sx={{ mb: 2 }}
          >
            {channels.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='cost'
            name='cost'
            label='One-time Cost'
            fullWidth
            autoComplete='cost'
            variant='outlined'
            value={state.cost}
            InputProps={{
              readOnly: true,
            }}
            sx={{ mb: 2 }}
          />
        </Grid>
        {state.applicationID.map((item) => (
          <Grid
            item
            xs={12}
            sm={12}
            key={item.key}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <TextField
              id={`${item.key}`}
              name='applicationID'
              label={
                'ApplicationID'
                // <Typography sx={{ display: 'flex' }}>
                //   ApplicationID{' '}
                //   {applicationFocus ? (
                //     <Tooltip
                //       title={
                //         <Typography color='inherit' sx={{ fontSize: '15px' }}>
                //           From a terminal on your system, <br /> run
                //           "tcx-dg-stt", to get your application id
                //         </Typography>
                //       }
                //       arrow
                //     >
                //       <HelpOutlineOutlinedIcon sx={{ marginLeft: '10px' }} />
                //     </Tooltip>
                //   ) : null}
                // </Typography>
              }
              helperText='From a terminal on your system, run "tcx-dg-stt", to get your application id'
              fullWidth
              onFocus={() => setApplicationFocus(true)}
              onBlur={() =>
                item.id.length ? null : setApplicationFocus(false)
              }
              autoComplete='application-ID'
              variant='outlined'
              sx={{
                mb: 2,
              }}
              value={item.id}
              onChange={(event) => onEdit(event)}
            />
          </Grid>
        ))}
        <Grid item xs={6} md={2}>
          <Button color='success' onClick={onAdd}>
            + Add
          </Button>
        </Grid>
        <Grid item xs={6} md={4}>
          <Button variant='text' color='error' onClick={onRemove}>
            - Remove
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
